import { i18nFilter } from "app/filters/i18nFilter";

import type { IPackagePrice } from "./types";

const MONTHS_PER_YEAR = 12;
const DEFAULT_PRICE = 0;

export const getUSDPrice = (packagePrices: IPackagePrice[] | undefined, defaultPrice = DEFAULT_PRICE): string => {
    if (!packagePrices) {
        return defaultPrice.toString();
    }
    const foundPackage = packagePrices.find((p) => p.Currency === "USD");
    const annualPrice = foundPackage ? foundPackage.Price : defaultPrice;
    return Math.floor(annualPrice / MONTHS_PER_YEAR).toString();
};

export const generateListItems = (numOfItems: number, keyPrefix: string, startIndex = 1): Array<{ item: string }> => {
    const translate = i18nFilter();
    return [...Array(numOfItems).keys()].map((_, index) => ({
        item: translate(`${keyPrefix}.item.${startIndex + index}`),
    }));
};

export const generateTitle = (values: string[]): string => {
    const translate = i18nFilter();
    return values.map((key) => translate(key)).join(" & ");
};
